// BUG-02: canonical automatic coverage (package vs direct) derivation for prestation lines.
// Single source of truth reused by every selection path so the derived economic mode is
// independent of the order in which service / client / dog fields are completed.
// Backend stays authoritative; this only picks the FORM default and never consumes credits.

export const activePkgFromList = (list) => (list || []).find((p) => (p.remaining_credits || 0) > 0) || null;

// Mirrors the historical defaultCoverage rule: an applicable package with enough remaining
// credits -> "package", otherwise "direct". Never invents eligibility.
export const coverageForDog = (pkgList, reqCredits) => {
  const p = activePkgFromList(pkgList);
  return p && (p.remaining_credits || 0) >= (reqCredits || 1) ? "package" : "direct";
};

// Recompute a single line's automatic coverage. Only touches values still in "auto" mode
// (coverage_auto / line_coverage_auto !== false) so an intentional manual override is preserved.
// Returns the SAME line reference when nothing changes (lets React bail out, no render loop).
export function recomputeLineCoverage(line, pkgByDog) {
  if (!line || !line.service_type_id || line.package_eligible === false) return line;
  const by = pkgByDog || {};
  if (line.price_scope === "per_dog") {
    let changed = false;
    const dogs = line.dogs.map((d) => {
      if (d.coverage_auto === false) return d;
      const want = coverageForDog(by[d.dog_id], d.required_credits || line.default_credits || 1);
      if (want !== d.coverage) { changed = true; return { ...d, coverage: want }; }
      return d;
    });
    return changed ? { ...line, dogs } : line;
  }
  if (line.line_coverage_auto === false) return line;
  const want = line.dogs.length === 1
    ? coverageForDog(by[line.dogs[0].dog_id], line.line_required_credits || line.default_credits || 1)
    : "direct";
  return want !== line.line_coverage ? { ...line, line_coverage: want } : line;
}

export function recomputeLinesCoverage(lines, pkgByDog) {
  let changed = false;
  const next = (lines || []).map((l) => { const nl = recomputeLineCoverage(l, pkgByDog); if (nl !== l) changed = true; return nl; });
  return changed ? next : lines;
}
